import React, { useEffect, useState, useCallback } from "react";
import { Field, getIn, useFormikContext } from "formik";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  IconButton,
  Text,
  Flex,
  RadioGroup,
  Stack,
  Box,
  Grid,
  GridItem,
  Button,
} from "@chakra-ui/react";

import { BsFillTrash3Fill } from "react-icons/bs";
import { RadioButtonFieldSecond } from "../RadioButtonFieldSecond";

import DoencaService from "../../../main/services/DoencaService";
import { CustomSelectWField } from "../CustomSelectWField";
import CustomDropzone from "../CustomDropzone";
import Swal from "sweetalert2";

const CustomFormSaude = () => {
  const [doencas, setDoencas] = useState({
    options: [],
    isLoading: false,
  });

  const { values, setFieldValue } = useFormikContext();
  const [componentes, setComponentes] = useState(values.tratamentos);

  useEffect(() => {
    setComponentes(values.tratamentos || []);
  }, [values.tratamentos]);

  const handleAddComponente = () => {
    const novoComponente = {
      fazTratamento: "",
      doenca: "",
      idSaudeDoenca: 0,
      laudoMedico: null,
    };
    if (componentes.length === 0) {
      setComponentes([novoComponente]);
      setFieldValue("tratamentos", [novoComponente]);
    } else {
      setComponentes([...componentes, novoComponente]);
      setFieldValue("tratamentos", [...componentes, novoComponente]);
    }
  };

  const handleRemoveComponente = (index) => {
    Swal.fire({
      title: "Atenção!",
      text: "Deseja realmente excluir a doença?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedComponentes = componentes.filter((_, i) => i !== index);
        setComponentes(updatedComponentes);
        setFieldValue("tratamentos", updatedComponentes);

        if (updatedComponentes.length === 0) {
          setFieldValue("tratamentos", []);
        }
      }
    });
  };

  const handleChange = (index, fieldName, value) => {
    const currentComponent = componentes[index];

    const updatedComponent = {
      ...currentComponent,
      [fieldName]: value,
    };

    const updatedComponentes = [...componentes];
    updatedComponentes[index] = updatedComponent;

    setComponentes(updatedComponentes);

    setFieldValue(`tratamentos[${index}]`, updatedComponent);
  };

  const handleGetDoencas = useCallback(() => {
    setDoencas((doencas) => ({ ...doencas, isLoading: true }));
    DoencaService.listarDoencaAtiva().then((res) => {
      const modifiedData = res.data.map((doenca) => {
        return {
          idDoenca: doenca.id,
          descricaoDoenca: doenca.descricao,
        };
      });
      setDoencas({ options: modifiedData, isLoading: false });
    });
  }, []);

  useEffect(() => {
    handleGetDoencas();
  }, [handleGetDoencas]);

  return (
    <Box>
      {componentes &&
        componentes.length > 0 &&
        componentes.map((componente, index) => (
          <Grid
            key={index}
            templateColumns="repeat(20, 1fr)"
            gap={4}
            mt={index > 0 && 4}
          >
            <GridItem colSpan={19}>
              <Grid
                templateColumns="repeat(3, 1fr) 1fr"
                key={index}
                gap={{ base: 10, xl: 25 }}
                border={"1px solid #DDEBEA"}
                px={2}
                py={2}
                justifyContent={"space-between"}
              >
                <GridItem
                  colSpan={{ base: 4, md: 1, xl: 1 }}
                  w={"200px"}
                  mt={-1}
                >
                  <CustomSelectWField
                    fieldName={`tratamentos[${index}].doenca`}
                    placeholder="Selecione a Doença"
                    getOptionLabel={(option) =>
                      option.descricaoDoenca || option.descricao
                    }
                    getOptionValue={(option) => option.idDoenca}
                    isLoading={doencas.isLoading}
                    options={doencas.options.filter(
                      (op) =>
                        !componentes
                          .filter((c, i) => i !== index)
                          .map((c) => c.doenca?.idDoenca || c.doenca?.id)
                          .includes(op.idDoenca),
                    )}
                    values={componente.doenca}
                    onChange={(value) => {
                      // setFieldValue(
                      //   `tratamentos[${index}].doenca`,
                      //   value ? value : ""
                      // );
                      handleChange(index, "doenca", value);
                    }}
                    onFocus={
                      doencas.options.length === 0 ? handleGetDoencas : null
                    }
                    visible={values.possuiProblemasSaude === "S"}
                  />
                </GridItem>
                <GridItem colSpan={{ base: 4, lg: 2, xl: 2 }}>
                  <Field name={`tratamentos[${index}].fazTratamento`}>
                    {({ field, form }) => (
                      <FormControl
                        display={"flex"}
                        isInvalid={
                          form.errors.tratamentos && form.touched.tratamentos
                        }
                      >
                        <FormLabel whiteSpace={"nowrap"}>
                          Faz Tratamento?*
                        </FormLabel>
                        <RadioGroup
                          value={componente.fazTratamento}
                          onChange={(value) => {
                            handleChange(index, "fazTratamento", value);
                          }}
                        >
                          <Stack direction="column" whiteSpace={"nowrap"}>
                            <RadioButtonFieldSecond
                              fieldName={`tratamentos[${index}].fazTratamento`}
                              value="N"
                              label="Não"
                            />
                            <RadioButtonFieldSecond
                              fieldName={`tratamentos[${index}].fazTratamento`}
                              value="P"
                              label="Sim (Permanente)"
                            />
                            <RadioButtonFieldSecond
                              fieldName={`tratamentos[${index}].fazTratamento`}
                              value="T"
                              label="Sim (Temporário)"
                            />
                            <FormErrorMessage>
                              {getIn(
                                form.errors,
                                `tratamentos[${index}].fazTratamento`,
                              ) &&
                                getIn(
                                  form.touched,
                                  `tratamentos[${index}].fazTratamento`,
                                ) &&
                                form.errors.tratamentos[index].fazTratamento}
                            </FormErrorMessage>
                          </Stack>
                        </RadioGroup>
                      </FormControl>
                    )}
                  </Field>
                </GridItem>
                <GridItem colSpan={{ base: 2, xl: 1 }}>
                  <CustomDropzone
                    whiteSpace={true}
                    formProps={{ setFieldValue }}
                    title="Laudo Médico"
                    fieldName={`tratamentos[${index}].laudoMedico`}
                    height="42px"
                    titleText="Informe validade do termo de guarda"
                  />
                </GridItem>
              </Grid>
            </GridItem>
            <GridItem colSpan={1}>
              <Flex alignItems={"center"} h={"full"}>
                <IconButton
                  icon={<BsFillTrash3Fill size={20} color="#9EA1AE" />}
                  aria-label="Excluir"
                  bg="transparent"
                  _hover={{ bg: "transparent" }}
                  size="sm"
                  onClick={() => handleRemoveComponente(index)}
                />
              </Flex>
            </GridItem>
          </Grid>
        ))}

      {componentes && componentes.length <= 0 && (
        <Text color="red" opacity={0.8} fontSize="12px">
          Por favor, adicione e informe o problema de saúde
        </Text>
      )}
      <Button
        onClick={handleAddComponente}
        mt="13px"
        py="5px"
        px="16px"
        h="32px"
        color="#FFF"
        backgroundColor="#169499"
        fontWeight={700}
        isDisabled={componentes.length === doencas.options.length}
        fontSize="15px"
        lineHeight="21.6px"
        _hover={{ bg: "#169499" }}
      >
        Adicionar
      </Button>
    </Box>
  );
};

export default CustomFormSaude;
